module.exports = __webpack_public_path__ + "img/menu.e500225.svg";